import { useEffect, useRef } from 'react'
import { io } from 'socket.io-client'
import { LIVE_CHATS } from 'socket-resources/namespaces/index'
import { LIVE_CHAT, LIVE_CHAT_DELETED } from 'socket-resources/event-constants/chat/index'
import { getAuthToken } from 'utils/common-services/cookie.service'
import { getSocketQueryParams } from 'utils/common-services/socketQueryParams.service'

const useLiveChatSocketNameSpace = () => {
  const socketRef = useRef(null)

  useEffect(() => {
    if (!socketRef.current) {
      const token = getAuthToken()
      socketRef.current = io(`${process.env.REACT_APP_BACKEND_URL_WS}${LIVE_CHATS}`, {
        transport: ['polling', 'websocket'],
        auth: token ? {
          authorization: `Bearer ${token}`
        } : {},
        query: getSocketQueryParams()
      })
    }
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect()
        socketRef.current = null
      }
    }
  }, [])

  const listenLiveChatsUpdateEvent = (cb) => {
    if (socketRef.current && cb) {
      const handler = (data) => {
        cb(data)
      }
      socketRef.current.on(LIVE_CHAT, handler)
      return () => {
        if (socketRef.current) {
          socketRef.current.off(LIVE_CHAT, handler)
        }
      }
    }
    return () => { }
  }

  const listenChatDeletedEvent = (cb) => {
    if (socketRef.current && cb) {
      const handler = (data) => {
        cb(data)
      }
      socketRef.current.on(LIVE_CHAT_DELETED, handler)
      return () => {
        if (socketRef.current) {
          socketRef.current.off(LIVE_CHAT_DELETED, handler)
        }
      }
    }
    return () => { }
  }

  return { listenLiveChatsUpdateEvent, listenChatDeletedEvent }
}

export default useLiveChatSocketNameSpace
